import { gql } from '@apollo/client';

export const SEND_INCOMING_GOODS_MAIL = gql`
    mutation SendIncomingGoodsMail($incomingGoodsInput: IncomingGoodsInputType!) {
        sendIncomingGoodsMail(incomingGoodsInput: $incomingGoodsInput)
    }
`;
